// All AI Assistant admin tabs (Conversations, SQL Audit, Usage) load a single
// page of this size rather than paginating server-side.
export const PAGE_SIZE = 500;

// Mirrors ChatFeedbackReportService.MaxExportRows: the CSV export keeps the
// newest rows up to this cap and does not report that it dropped the rest.
export const FEEDBACK_EXPORT_MAX_ROWS = 10_000;
